import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  name: 'Natalia',
  age: 42,
  text: 'Después de años sintiéndome no elegida, estos 3 días fueron el inicio del cambio de mi energía completamente. Ahora tengo la relación que siempre soñé unos meses luego de hacerlo, Gracias Paty!!!.'
}, {
  name: 'Susana',
  age: 38,
  text: 'No podía creer que algo tan simple pudiera como 3 Clases y una Meditación pudieran cambiar tanto 🥹. Dejé de atraer hombres tóxicos y encontré a mi pareja ideal luego de terminarlo ❤️'
}, {
  name: 'Ana',
  age: 45,
  text: 'Paty me ayudó a ver que el problema no era encontrar amor, sino amarme a mí misma primero. Acabo de bloquear al toxico, ahora si estoy lista para manifestar a mi compañero de vida.'
}];
export function Testimonials() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white text-center" data-id="element-145">
      <div className="max-w-5xl mx-auto" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-147">
          <div className="text-4xl mb-4" data-id="element-148">🗣️</div>
          <img src="https://cdn.magicpatterns.com/uploads/ixXTx789TpweCvJ6BGpwAe/Captura_de_pantalla_2026-04-28_a_la(s)_9.38.56_p._m..png" alt="Comunidad de mujeres en sesión" className="w-full max-w-2xl mx-auto rounded-2xl shadow-lg mb-8 object-cover" data-id="element-149" />
          <h2 className="text-3xl sm:text-4xl font-bold text-dark mb-12" data-id="element-150">
            Lo que dicen las mujeres que ya lo vivieron
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-151">
            {testimonials.map((t, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="bg-beige-50 p-8 rounded-2xl relative border border-beige-100" data-id="element-152">
                <Quote className="w-10 h-10 text-gold-300 absolute top-4 left-4 opacity-50" data-id="element-153" />
                <p className="text-gray-700 italic mb-6 relative z-10 pt-4" data-id="element-154">
                  "{t.text}"
                </p>
                <div className="border-t border-beige-200 pt-4" data-id="element-155">
                  <p className="font-bold text-dark" data-id="element-156">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-157">{t.age} años</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}